import HTTPClient from '../common/http-client'

/**
 * タスクサービス
 */
export default class TaskService {
  static getInstance() {
    if (!this.taskService) {
      this.taskService = new TaskService()
    }
    return this.taskService
  }

  constructor() {
    this.httpClient = HTTPClient.getInstance().http
  }

  /**
   * タスクの未ソート データを取得する
   * @param {object} queryParam ソートされていない検索データのリクエスト
   * @returns テーブル タスクのデータが並べ替えられない
   */
  async getMissingItems(queryParam) {
    const paramsObj = {params: queryParam}
    const res = await this.httpClient.get('/func/get-missing-items', paramsObj)
    return res
  }
}



// WEBPACK FOOTER //
// ./src/_services/task.service.js